var render = function (_h,_vm) {var _c=_vm._c;return _c('main',[_c('div',[_c('div',{staticClass:"bg"}),_c('h3',[_vm._v("we are here to help you")]),_c('router-link',{staticClass:"btn",attrs:{"to":"/actions"}},[_vm._v("Start Now")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }